Revolution.Module.extend({
    NAME: "mde.popins", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        $('.js-show-popin').magnificPopup();

        $('.popin-iframe').magnificPopup({
            delegate: '.js-show-popin-iframe',
            mainClass: 'mfp-fade',
            type: 'iframe'
        });

        $('.js-show-popin.-no-bg').on('mfpOpen', function (e /*, params */) {
            $('.mfp-bg').addClass('bg-transp');
        });
        $('.js-show-popin.-no-bg').on('mfpClose', function (e /*, params */) {
            $('.mfp-bg').removeClass('bg-transp');
        });

        $('body').on('click', '.js-close-popin', function () {
            $('.simple-popup-blocks-global').hide();
            $('body').css('overflow', 'auto');
        });

        $('body').on('click', '.spb_overlay', function () {
            $('.simple-popup-blocks-global').hide();
            $('body').css('overflow', 'auto');
        });


        $('body').magnificPopup({
            delegate: '.js-show-popin-gallery',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            }
        });

        $('.js-show-img').magnificPopup({
            mainClass: 'mfp-img-full mfp-fade',
            closeMarkup: '<button title="Close" type="button" class="mfp-close btn -no-border"><span class="icon-close"></span></button>',
            removalDelay: 500,
            items: {
                type: 'inline',
            },
            callbacks: {
                elementParse: function(item) {
                    var magnificPopup = $.magnificPopup.instance,
                    cur = magnificPopup.st.el;
                    var cloneHTML = cur.find('.media-wrapper').clone();
                    item.src = cloneHTML;
                }
            },
        });
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    }
});
